import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";

const Tabs = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (tab) => {
    return location.pathname === `${process.env.PUBLIC_URL}/${tab}`;
  };

  const { t } = useTranslation();

  return (
    <>
      <div className="jana_pmbi_innersec">
        <div className="jana_pmbi_tabsec tabs pt-4 pb-2">
          <ul className="row nav nav-pills" id="pills-tab" role="tablist">

            <li className="col-md-4 nav-item " role="presentation">

              <button
                id="headingColor" className={`nav-link ${isActive("pmbjb-scheme") ? "active" : ""}`}
                data-bs-toggle="pill"
                onClick={() =>
                  navigate(`${process.env.PUBLIC_URL}/pmbjb-scheme`)
                }
                type="button"
                role="tab"
                aria-controls="pills-tab1"
                aria-selected={isActive("pmbjb-scheme")}
              >
                {t("PMBJPScheme")}
              </button>
            </li>
            <li className="col-md-4 nav-item" role="presentation">
              <button
                id="headingColor" className={`nav-link ${isActive("locate-kendra") ? "active" : ""}`}
                data-bs-toggle="pill"
                onClick={() =>
                  navigate(`${process.env.PUBLIC_URL}/locate-kendra`)
                }

                type="button"
                role="tab"
                aria-controls="pills-tab3"
                aria-selected={isActive("locate-kendra")}
              >
                {t("LocatePMBJPKendra")}
              </button>
            </li>
            <li className="col-md-4 nav-item" role="presentation">
              <button
                id="headingColor" className={`nav-link ${isActive("locate-distributor") ? "active" : ""}`}
                data-bs-toggle="pill"
                onClick={() =>
                  navigate(`${process.env.PUBLIC_URL}/locate-distributor`)
                }

                type="button"
                role="tab"
                aria-controls="pills-tab3"
                aria-selected={isActive("locate-distributor")}
              >
                {t("LocateDistributor")}
              </button>
            </li>
            <li className="col-md-4 nav-item" role="presentation">
              <button
                id="headingColor" className={`nav-link ${isActive("pm-hospital") ? "active" : ""}`}

                data-bs-toggle="pill"
                onClick={() =>
                  navigate(`${process.env.PUBLIC_URL}/pm-hospital`)
                }

                type="button"
                role="tab"
                aria-controls="pills-tab3"
                aria-selected={isActive("pm-hospital")}
              >
                {t("ABPMJAYHospital")}
              </button>
            </li>
            <li className="col-md-4 nav-item" role="presentation">
              <button
                id="headingColor" className={`nav-link ${isActive("annual-report") ? "active" : ""}`}

                data-bs-toggle="pill"
                onClick={() =>
                  navigate(`${process.env.PUBLIC_URL}/annual-report`)
                }

                type="button"
                role="tab"
                aria-controls="pills-tab3"
                aria-selected={isActive("annual-report")}
              >
                {t("AnnualReport")}
              </button>
            </li>
            <li className="col-md-4 nav-item" role="presentation">
              <button
                id="headingColor" className={`nav-link ${isActive("finance-report") ? "active" : ""}`}

                data-bs-toggle="pill"
                onClick={() =>
                  navigate(`${process.env.PUBLIC_URL}/finance-report`)
                }

                type="button"
                role="tab"
                aria-controls="pills-tab3"
                aria-selected={isActive("finance-report")}
              >
                {t("FinancialReport")}
              </button>
            </li>
            {/* <li className="col-md-4 nav-item" role="presentation">
                <button
                  className={`nav-link ${isActive("pharma-details") ? "active" : ""}`}
                  id="pmbi-tab8"
                  data-bs-toggle="pill"
                  onClick={() =>
                    navigate(`${process.env.PUBLIC_URL}/pharma-details`)
                  }
                  data-bs-target="#pmbi-tab3-data"
                  type="button"
                  role="tab"
                  aria-controls="pills-tab3"
                  aria-selected={isActive("pharma-details")}
                >
                              {t("PharmacistDetails")}
                </button>
              </li> */}
            <li className="col-md-4 nav-item" role="presentation">
              <button
                id="headingColor" className={`nav-link ${isActive("faq") ? "active" : ""}`}

                data-bs-toggle="pill"
                onClick={() =>
                  navigate(`${process.env.PUBLIC_URL}/faq`)
                }

                type="button"
                role="tab"
                aria-controls="pills-tab3"
                aria-selected={isActive("faq")}
              >
                {t("FAQs")}
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Tabs;
